const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
// @ components
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKIconTask } = require('commonsComponents/OKIconTask');
// @ commons
const {formatText, FormattedText} = require('core/i18n').i18n;
// @ utilities
const { removeCurrentSectionOption } = require('utilities/moreOptionsHelper');

class CardStatementMoreOptionsButton extends React.Component {
    buildMoreOptions (cardId, statementId) {

        let options = [
            {
                visible: true,
                link: `/myprofile/cards/${cardId}/statement/detail/${statementId}`,
                text: formatText('cardStatementMoreOptions-detail')
            }
        ];

        return removeCurrentSectionOption(options);
    }

    render() {
        const {immCard, statementId} = this.props;
        const moreOptions = this.buildMoreOptions(immCard.get('cardId'), statementId);
        const targetElement = (
            <div className="card-more-options-button">
                <div className="hidden-xs">
                    <OKButton
                        modifier="ghost"
                        inverse={true}
                        rightIcon="icon-dropdown-abrir"
                        smallRightIcon={true}
                    >
                        <FormattedText value="cards-moreOptions" />
                    </OKButton>
                </div>
                <div className="visible-xs">
                    <OKIconTask activeHover={false} icon="icon-s-op-comp" type="standalone" style="dark-bg" />
                </div>
            </div>
        );

        return (
            <PopoverMenu
                target={targetElement}
                items={moreOptions}
                placement="bottomRight"
            />
        );
    }
}

CardStatementMoreOptionsButton.propTypes = {
    immCard: PropTypes.object.isRequired,
    statementId: PropTypes.string.isRequired
};

module.exports = CardStatementMoreOptionsButton;